import { render } from "./PlanCobraSummary.vue?vue&type=template&id=4db8ba5f&ts=true"
import script from "./PlanCobraSummary.vue?vue&type=script&lang=ts"
export * from "./PlanCobraSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__